import React from "react";
import styled from "styled-components";
import { FaChevronRight } from "react-icons/fa";
import { deviceSize } from "../responsive";
import { Link } from "react-router-dom";



// this link was animate scroll
//import { Link, animateScroll as scroll } from "react-scroll";

const SidebarContainer=styled.aside`
 position:fixed;
 z-index:2;
 width:294px;
 height:100%;
 background: #fff; 
 display:flex;
 flex-direction:column;
 align-items: flex-start;
 right:0;
 top:1em;
 transition:0.3 ease-in-out;
 opacity:${({isOpen}) => (isOpen ? '100%': '0')};
 top:${({isOpen}) =>(isOpen ? '0': '-100%')};
`;


const Icon = styled.div`
position: absolute;
top:.7em;
right:2.5rem;
background:trasparent;
font-size:2rem;
cursor:pointer;
outline:none;
color:#000;

`;


const SidebarMenu=styled.ul`

	display: inline-block; 
	text-align: center;
	margin-left: 0;
	margin-top: 20%;
	padding-left: 0;
    width: 100%;
	
	@media screen and (max-width:${deviceSize.mobile}px){
	 	 grid-template-rows:repeat(9,10px);

	 }

`;


const SidebarLink=styled.li`

font-family: 'Sunflower';
font-style: normal;
font-weight: 100;
font-size: 13px;
line-height: 16px;
color:#000;
list-style: none;
text-decoration: none;
padding-left: 10%;



 background:
    linear-gradient(
      to left, 
      rgba(52,52,52,9%) 30%,
      rgba(54,54,48,15%) 70%,
      rgba(52,52,52,9%) 30%
    )
    left 
    bottom  
    no-repeat; 
  background-size:90% 2px;


  @media screen and (-webkit-min-device-pixel-ratio: 0) {
    &:hover {
      background-image: none; 
      background-color: #EBD5D5; 
    }	
   }
`;

/* const home = styled.img`
  background: {Home} no-repeat left top;
  height: 34px;
  padding-top: 7px;
  padding-left: 44px;
`;

const SidebarLinknb=styled.li`

font-family: 'Sunflower';
font-style: normal;
font-weight: 100;
font-size: 13px;
line-height: 16px;
color:#000;
;

	&:hover{
		filter:contrast(0.6);
		color:#f7eeee;

	}

`; */


const SideBarLogo= styled.div`
  width: 294px;
  height: 64px;
  -webkit-backdrop-filter: blur(50px);
  backdrop-filter: blur(50px);
  background-color: rgba(255, 255, 255, 0.1);

`;




/* 



const ImageWrapper=styled.div`
    align-items:center;
    width: 30px;
    height: 34px;

`;


const linkP=styled.p`
	
	width:150px;
	font-family:'Sunflower';
	font-style:normal;
	font-weight:100;
	font-size: 13px;
	line-height: 16px;
	display: inline-block; 
	text-align: left; 

`; */

// const Link =  styled.a`
// 	text-decoration: none;
// `;




export function SideBar({props ,  isOpen, toggle }) {
	// const isMobile =useMediaQuery({ maxWidth: deviceSize.mobile });


	return (
		<SidebarContainer id="sidebar-container"isOpen={isOpen} onClick={toggle}>
		 <SideBarLogo>
			<Icon onClick={toggle}>
			 <FaChevronRight styled={{height:14,width:8}}/>		
			</Icon>	
		 </SideBarLogo>
		
		 <SidebarMenu> 

			<Link to="/" style={{textDecoration: "none"}} onClick={() => window.scrollTo(0, 0)}>
				<SidebarLink>
			 		Home
				</SidebarLink>
			</Link>
			
			<Link to="/blogs" style={{textDecoration: "none"}} onClick={() => window.scrollTo(0, 0)}>
				<SidebarLink>
					The Exp Blog
				</SidebarLink>
			</Link>


			<Link to="/techstaffing" style={{textDecoration: "none"}} onClick={() => window.scrollTo(0, 0)}>
				<SidebarLink>
					Tech Staffing
				</SidebarLink>
			 </Link>
 
      		<Link to="/financestaffing" style={{textDecoration: "none"}} onClick={() => window.scrollTo(0, 0)}>
			 	<SidebarLink>
					Finance Staffing
			 	</SidebarLink>
			 </Link>


			<Link to="/callcenterstaffing" style={{textDecoration: "none"}} onClick={() => window.scrollTo(0, 0)}>
			 	<SidebarLink>
					Call Center Staffing
			 	</SidebarLink>
			</Link >

			<Link to="/healthcompliance" style={{textDecoration: "none"}}>
				<SidebarLink>
					Health Compliance
				</SidebarLink>
			</Link>

			<Link to="/staffing" style={{textDecoration: "none"}} onClick={() => window.scrollTo(0, 0)}>
				<SidebarLink>
					Our Process
				</SidebarLink>
			</Link>

			<Link to="/careers" style={{textDecoration: "none"}} onClick={() => window.scrollTo(0, 0)}>
				<SidebarLink>
					Professional Development
				</SidebarLink>
			</Link>

			<Link to="getfoodnyc" style={{textDecoration: "none"}} onClick={() => window.scrollTo(0, 0)}>
				<SidebarLink>
					GetFoodNYC Case Study
				</SidebarLink>
			</Link>
			</SidebarMenu>
		</SidebarContainer>

		);

}

